// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DeleteConfirmationModal_dialog__1d6gj"};